<template>
  <div class="app-container">
    <el-form v-show="showSearch" ref="queryForm" :inline="true" :model="queryParams" label-width="68px" size="small">
      <el-form-item label="用户" prop="userId">
        <el-select v-model="queryParams.userId" :style="{width: '100%'}"
                   filterable
                   clearable
                   remote
                   :remote-method="getUserList"
                   placeholder="输入手机号或者姓名搜索"  @keyup.enter.native="handleQuery">
          <el-option v-for="(item, index) in userList" :key="index" :disabled="item.disabled"
                     :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报告名称" prop="reportName">
        <el-input
          v-model="queryParams.reportName"
          clearable
          placeholder="请输入报告名称"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="日期">
        <el-date-picker
            v-model="dateRange"
            size="small"
            style="width: 240px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" size="mini" type="primary" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          v-hasPermi="['biz:ReportUserTotal:add']"
          icon="el-icon-plus"
          plain
          size="mini"
          type="primary"
          @click="handleAdd"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          v-hasPermi="['biz:ReportUserTotal:edit']"
          :disabled="single"
          icon="el-icon-edit"
          plain
          size="mini"
          type="success"
          @click="handleUpdate"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          v-hasPermi="['biz:ReportUserTotal:remove']"
          :disabled="multiple"
          icon="el-icon-delete"
          plain
          size="mini"
          type="danger"
          @click="handleDelete"
        >删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          v-hasPermi="['biz:ReportUserTotal:export']"
          icon="el-icon-download"
          plain
          size="mini"
          type="warning"
          @click="handleExport"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="totalList" @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="55" />
      <el-table-column align="center" label="用户姓名" prop="userName" />
      <el-table-column align="center" label="用户手机号" prop="userPhone" />
      <el-table-column align="center" label="报告名称" prop="reportName" />
      <el-table-column align="center" label="状态" prop="status">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="2"
              @change="handleStatusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="报告时间" prop="reportDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.reportDate, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" class-name="small-padding fixed-width" label="操作">
        <template slot-scope="scope">
          <el-button
            v-hasPermi="['biz:ReportUserTotal:edit']"
            icon="el-icon-edit"
            size="mini"
            type="text"
            @click="handleUpdate(scope.row)"
          >修改</el-button>
          <el-button
            v-hasPermi="['biz:ReportUserTotal:remove']"
            icon="el-icon-delete"
            size="mini"
            type="text"
            @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :limit.sync="queryParams.pageSize"
      :page.sync="queryParams.pageNum"
      :total="total"
      @pagination="getList"
    />

    <!-- 添加或修改用户报告主记录对话框 -->
    <el-drawer
      :title="title"
      :visible.sync="open"
      direction="rtl"
      size="70%"
    >
      <div class="p-16" style="height: 100%">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="height: calc(100% - 50px); overflow: auto">
          <el-row>
            <el-col :span="8">
              <el-form-item label="用户id" prop="userId">
                <el-select 
                  :disabled="isEdit"
                  v-model="form.userId"
                  :style="{width: '100%'}"
                  filterable
                  remote
                  :remote-method="searchListUserAllinfo"
                  @change="handleUserChange"
                  placeholder="输入手机号或者姓名搜索">
                  <el-option v-for="(item, index) in personList" :key="index" :disabled="item.disabled"
                    :label="item.label" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="报告名称" prop="reportTotalName">
                <el-input v-model="form.reportTotalName" placeholder="示例：术后3月" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="报告时间" prop="reportDate">
                <el-date-picker 
                  v-model="form.reportDate"
                  clearable
                  placeholder="这里就是报告的时间"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="display: flex;justify-content: flex-end;padding: 10px 0">
            <el-button type="primary" @click="submitReportFormAll" v-loading="formLoading">一键同步</el-button>
          </div>
          <el-table
            :data="form.templateParamV2List || []"
            border
            style="width: 100%"
          >
            <el-table-column
              fixed
              prop="templateName"
              label="模板"
              width="200">
            </el-table-column>
            <el-table-column
              prop="report"
              label="院内报告"
              width="300"
            >
            <template slot-scope="scope">
              <div class="ds-f">
                <el-select :value="scope.row.sourceId" :style="{width: '100%'}"
                  placeholder="选择报告"
                  filterable
                  remote
                  reserve-keyword
                  @change="(value) => handleReportChange(value, scope.row)"
                >
                  <el-option v-for="(item, index) in scope.row.reportList || []" :key="index" :disabled="item.disabled"
                    :label="item.reportTypeName" :value="item.hisReportId">
                    <div style="width: 700px;display: flex;justify-content: space-between;">
                      <div v-if="item.used" style="width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">【已使用】</div>
                      <div style="width: 400px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ item.reportTypeName }}</div>
                      <div style="width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ item.diagnosis }}</div>
                      <div>{{item.issued}}</div>
                    </div>
                  </el-option>
                </el-select>
                <el-button type="primary" plain @click="handleSyncReport(scope.row)" style="margin-left: 10px;">同步</el-button>
              </div>
            </template>
            </el-table-column>
            <el-table-column
              prop="other"
              label="已同步数据">
            <template slot-scope="scope">
              <div v-if="scope.row.attributeParamV2List && scope.row.attributeParamV2List.length > 0 && scope.row.apiType === 'searchCommLabRepByPatInfo'">
                <label>报告总项数：</label><span>{{scope.row.total}}</span>&nbsp;&nbsp;
                <label class="ml-12">同步项数：</label><span style="color: #1890ff; font-weight: bold;">{{scope.row.finished}}</span>&nbsp;&nbsp;
                <label class="ml-12">未同步项数：</label><span style="color: red; font-weight: bold;">{{scope.row.unfinished}}</span>
              </div>
              <div v-if="scope.row.attributeParamV2List && scope.row.attributeParamV2List.length > 0 && scope.row.apiType === 'searchExamReportByPatientInfo'">
                <ul>
                  <li>
                    <label>影像所见：</label>
                    <span>{{scope.row.attributeParamV2List[0].diagnosis}}</span>
                  </li>
                  <li>
                    <label>影像提示：</label>
                    <span>{{scope.row.attributeParamV2List[0].result}}</span>
                  </li>
                  <li>
                    <label>报告链接：</label>
                    <a target="_blank" :href="scope.row.originPDF">{{scope.row.originPDF}}</a>
                  </li>
                </ul>
              </div>
            </template>
            </el-table-column>
            
            <el-table-column
                prop="other" width="100"
                label="操作">
              <template slot-scope="scope">
                <div v-if="scope.row.attributeParamV2List && scope.row.attributeParamV2List.length > 0 && scope.row.apiType === 'searchCommLabRepByPatInfo'">
                  <div><el-button type="primary" plain @click="handleSyncReport(scope.row, true)" style="margin-left: 10px;">修改</el-button></div>
                </div>
                <div v-else>
                  <el-button v-if="scope.row.apiType === 'searchCommLabRepByPatInfo'" type="primary" plain @click="handleSyncReport(scope.row, true)" style="margin-left: 10px;">新增</el-button>
                </div>
                <div v-if="scope.row.attributeParamV2List && scope.row.attributeParamV2List.length > 0 && scope.row.apiType === 'searchExamReportByPatientInfo'">
                  <el-button type="primary" plain @click="handleSyncReport(scope.row, true)" style="margin-left: 10px;">修改</el-button>
                </div>
                <div v-else>
                  <el-button v-if="scope.row.apiType === 'searchExamReportByPatientInfo'" type="primary" plain @click="handleSyncReport(scope.row, true)" style="margin-left: 10px;">新增</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right;margin-top: 12px;margin-bottom: 20px;">
          <el-button type="primary" @click="submitForm">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 同步报告数据 -->
    <el-dialog title="同步数据" :visible.sync="openReport" append-to-body width="1000px">
      <el-button type="primary" @click="copyReportResultList">粘贴结果列</el-button>
      <el-table :data="attributeParamV2List" >
        <el-table-column align="center" label="编码" prop="attributeCode">
          <template slot-scope="scope">
            <span>{{scope.row.attributeCode}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="项目" prop="attributeName" >
          <template slot-scope="scope">
            <span>{{scope.row.attributeName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结果" prop="result" >
          <template slot-scope="scope">
            <el-input type="text" v-model="scope.row.result" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="单位" prop="attributeUnit" >
          <template slot-scope="scope">
            <span>{{scope.row.attributeUnit}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="取值范围" prop="rangeShow" >
          <template slot-scope="scope">
            <span>{{scope.row.rangeShow}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitReportForm">确 定</el-button>
        <el-button @click="openReport = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 彩超同步数据 -->
    <el-dialog v-if="openReportB" title="同步数据" :visible.sync="openReportB" destroy-on-close append-to-body width="1000px">
      <el-form ref="formB" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="影像所见" prop="diagnosis">
              <el-input
                type="textarea"
                :rows="10"
                placeholder="影像所见"
                v-model="current.bData.diagnosis">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="影像提示" prop="result">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="影像提示"
                v-model="current.bData.result">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="源报告" prop="originPDF">
              <image-upload :fileType='["png", "jpg", "jpeg", "pdf", "PDF"]' v-model="current.bData.originPDF" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBReportForm">确 定</el-button>
        <el-button @click="openReportB = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addReportUserTotal,
  delReportUserTotal,
  getReportUserTotal,
  listReportUserTotal,
  updateReportUserTotal,
  listReportTemplateDetail,
  getHisReportResult,
  getHisReportAttributeResult,
  getReportTotalById,
  saveOrUpdate
} from "@/api/biz/ReportUserTotal";
import {searchListUser, searchListUserAllinfo} from "@/api/biz/User";
import {searchListTencentOcr} from "@/api/biz/TencentOcr";
import {changeUserStatus} from "@/api/system/user";


export default {
  name: "ReportUserTotal",
  data() {
    return {
      // 日期范围
      dateRange: [],
      searchUserKey: null,
      searchRemarkKey: null,
      userList: [],
      personList: [],
      attributeParamV2List: [],
      // tencentOcrList: [],
      // 遮罩层
      loading: true,
      formLoading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户报告主记录表格数据
      totalList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 记录当前同步的模板和报告
      current: {
        templateId: null,
        userId: null,
        bData: {},  // B超数据
      },
      // 同步报告
      openReport: false,
      // B超数据同步
      openReportB: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userId: null,
        reportName: null,
        reportDate: null,
        createDate: null
      },
      // 表单参数
      form: {
        templateParamV2List:[],
      },
      isEdit: false,
      // 表单校验
      rules: {
        userId: [
          { required: true, message: "用户不能为空", trigger: "change" }
        ],
        reportTotalName: [
          { required: true, message: "报告名称不能为空", trigger: "change" },
          { max: 15, message: "长度不能超过15个字符", trigger: "blur" }
        ],
        reportDate: [
          { required: true, message: "报告时间不能为空", trigger: "change" }
        ],
        templateId: [
         { required: true, message: "模板不能为空", trigger: "change" }
        ]
      }
    };
  },
  created() {
    // this.searchListTencentOcr();
    this.getList();
    this.getUserList();
  },
  methods: {
    handleStatusChange(row) {
      let text = row.status == "1" ? "启用" : "停用";
      this.$modal.confirm('确认要"' + text + '""' + row.reportName + '"吗？').then(function() {
        return updateReportUserTotal(row);
      }).then(() => {
        this.$modal.msgSuccess(text + "成功");
      }).catch(function() {
        row.status = row.status === 1 ? 2 : 1;
      });
    },
    getUserList(searchUserKey) {
      searchListUser({ "searchUserKey" : searchUserKey }).then(res => {
        this.userList = res.data;
      })
    },
    searchListUserAllinfo(searchUserKey, userId) {
      searchListUserAllinfo({ "searchUserKey" : searchUserKey, userId }).then(res => {
        this.personList = res.data?.map(item => {
          item.label = (item.cpName || '-') + '&' + (item.idNumber || '-');

          return item;
        });

        if(this.isEdit) {
          let currentUser = this.personList.find(item => item.id === this.form.userId);
          if(currentUser) {
            listReportTemplateDetail({ gender: currentUser.gender, userId: this.form.userId }).then(response => {
              let _templateParamV2List = [...this.form.templateParamV2List || []];

              _templateParamV2List = _templateParamV2List.map(item => {
                let findTemplate = response.data.find(item2 => item2.id === item.templateId);

                item.id = item.templateId;

                // 将报告下拉数据写入
                if(findTemplate) {
                  item.reportList = findTemplate.hisUserReportVoList || [];
                }
                // 计算同步数据
                if(item.attributeParamV2List && item.attributeParamV2List.length > 0) {
                  let totalData = this.getReportComplete(item);
                  item = {
                    ...item,
                    ...totalData,
                  };
                }
                return item;
              })
              this.form = {
                ...this.form,
                templateParamV2List: _templateParamV2List
              };
            })
          } else {
            return this.$message({
              message: '数据异常，未找到当前患者数据，检查该用户是否录入身份证号',
              type: 'warning'
            });
          }
        }
      })
    },
    // searchListTencentOcr(searchRemarkKey) {
    //   searchListTencentOcr({"remark": searchRemarkKey  }).then(res => {
    //     this.tencentOcrList = res.data;
    //   })
    // },
    // 用户切换
    handleUserChange(value) {
      let currentUser = this.personList.find(item => item.id === value);

      if(!currentUser || !currentUser.gender) {
        this.form = {
          ...this.form,
          templateParamV2List: []
        }
        return this.$message({
          message: '患者缺少身份证信息和性别信息',
          type: 'warning'
        });
      }
      this.searchReportTemplate(currentUser.gender, currentUser.id);
    },
    // 请求模板数据
    searchReportTemplate(gender, userId) {
      listReportTemplateDetail({ gender, userId }).then(response => {
        
        this.form = {
          ...this.form,
          templateParamV2List: (response.data || []).map(item => {
            const { hisUserReportVoList, ...other } = item;

            return {
              ...other,
              templateId: item.id || item.templateId,
              reportList: hisUserReportVoList || []
            };
          })
        };

      })
    },
    handleReportChange(reportId, record) {
      let templateParamV2List = this.form.templateParamV2List.map(item => {
        if (item.templateId === record.id) {
          item.sourceId = reportId;
          item.isUpdated = false;

          if(item.apiType === 'searchExamReportByPatientInfo') {
            let date = '';
            // 新增时获取第一个报告的时间
            let current = item.reportList?.find(it => it.hisReportId === reportId);
            date = current ? current.issued : '';

            this.form = {
              ...this.form,
              reportDate: date
            };
          }
          
        }
        return item;
      })

      this.form = {
        ...this.form,
        templateParamV2List: templateParamV2List

      }
      
    },
   
    /**
     * 同步报告
     * @param {*} record 本条数据
     * @param {*} update 是否是修改
     */
    handleSyncReport(record, update) {
      let that = this;

      // B超 不需要获取报告字段
      if(record.apiType === 'searchExamReportByPatientInfo') {
        if(!record.sourceId && !update) {
          return this.$message({
            message: '请选择报告',
            type: 'warning'
          });
        }
        if(update) {
          const { originPDF } = record;
          if(record?.attributeParamV2List?.[0]) {
            const { result, diagnosis } = record?.attributeParamV2List?.[0] || {};

            this.current.templateId = record.templateId;
            this.current.bData = {
              result: result || ' ',
              diagnosis: diagnosis || ' ',
              originPDF: originPDF ? [originPDF] : '' 
            };
          } else {
            getHisReportAttributeResult({ apiType: record.apiType, templateId: record.templateId }).then(response => {
              that.attributeParamV2List = response.data || [];
              that.current.templateId = record.templateId;
              const { result, diagnosis } = that.attributeParamV2List?.[0] || {};
              console.log(result, diagnosis, 'dasfds')

              this.current.bData = {
                result: result || ' ',
                diagnosis: diagnosis || ' ',
                originPDF: originPDF ? [originPDF] : ''
              };
            })
          }
          
        } else {
          let currentReport = record.reportList.find(item => item.hisReportId === record.sourceId);
          if(!currentReport) {
            return this.$message({
              message: '未找到当前报告无法同步！',
              type: 'warning'
            });
          }

          const { originPDF } = currentReport;
          getHisReportAttributeResult({ hisReportId: record.sourceId, apiType: record.apiType, templateId: record.templateId }).then(response => {
            that.attributeParamV2List = response.data || [];
            that.current.templateId = record.templateId;
            const { result, diagnosis } = that.attributeParamV2List?.[0] || {};
            that.current.bData = {
              result: result || ' ',
              diagnosis: diagnosis || ' ',
              originPDF: originPDF ? [originPDF] : ''

            };
          })
          // this.current.templateId = record.templateId;
          // this.current.bData = {
          //   result: currentReport.result,
          //   diagnosis: currentReport.diagnosis
          // };

        }
        this.openReportB = true;

      }
      // 普通检测报告
      if(record.apiType === 'searchCommLabRepByPatInfo') {
        if(!record.sourceId && !update) {
          return this.$message({
            message: '请选择报告',
            type: 'warning'
          });
        }
        if(!record.templateId) {
          return this.$message({
            message: '模板id（templateId）不能为空',
            type: 'warning'
          });
        }
        // 如果是修改，使用已有数据
        if(update) {
          if(record.attributeParamV2List?.length > 0) {
            this.attributeParamV2List = record.attributeParamV2List || [];
            this.openReport = true;
            this.current = {
              templateId: record.templateId,
            };
          } else {
            getHisReportAttributeResult({ hisReportId: record.sourceId, apiType: record.apiType, templateId: record.templateId }).then(response => {
              that.attributeParamV2List = response.data || [];
              that.openReport = true;
              that.current.templateId = record.templateId
            })
          }
         
        } else {
          const _record = {...record};
          getHisReportAttributeResult({ hisReportId: record.sourceId, apiType: record.apiType, templateId: record.templateId }).then(response => {
            that.attributeParamV2List = response.data || [];
            that.openReport = true;

            that.current.templateId = _record.templateId;

          })
        }
        
      }
    },

    // 普通检查项目数据同步
    submitReportForm() {
      const { templateId } = this.current;

      let templateParamV2List = [...(this.form.templateParamV2List || [])];
      templateParamV2List = templateParamV2List.map(item => {
        if(item.templateId === templateId) {
          item.attributeParamV2List = this.attributeParamV2List || [];
          console.log(this.attributeParamV2List, templateId, item);

          let totalData = this.getReportComplete(item);
          item = {
            ...item,
            ...totalData,
            isUpdated: true,

          };
        }

        return item;
      });

      this.form = {
        ...this.form,
        templateParamV2List: templateParamV2List
      }
      console.log(this.form);
      this.openReport = false;

    },

    // 一次性同步
    async submitReportFormAll() {
      let that = this;
      let templateParamV2List = [...(this.form.templateParamV2List || [])];
      console.log(templateParamV2List, 'templateParamV2ListtemplateParamV2List')
      this.formLoading = true;

      const _templateParamV2ListPromises = templateParamV2List.map((item) => this.getPromiseData(item));
      const _templateParamV2List = await Promise.all(_templateParamV2ListPromises);
      console.log(_templateParamV2List, 'templateParamV2ListtemplateParamV2List')
      this.formLoading = false;

      this.form = {
        ...this.form,
        templateParamV2List: _templateParamV2List
      }
    },

    getPromiseData(item) {
      let that = this;
      return new Promise((resolve) => {
        async function exec() {
          console.log(item.sourceId, !!item.isUpdated)
          if(item.sourceId && !item.isUpdated) {
            const templateId = item.sourceId;

            let params = {};
            if(item.apiType === 'searchExamReportByPatientInfo') {
              params = {
                hisReportId: item.sourceId, apiType: item.apiType, templateId: item.templateId
              };
            } else if(item.apiType === 'searchCommLabRepByPatInfo') {
              params = {
                hisReportId: item.sourceId, apiType: item.apiType, templateId: item.templateId
              }
            }
            const data = await getHisReportAttributeResult(params)
            
            console.log(data, 'datatatatat');

            item.attributeParamV2List = data?.data || [];

            let totalData = that.getReportComplete(item);
            item = {
              ...item,
              ...totalData,
              isUpdated: true
            };
            console.log(item, 'itemitemitem')

            resolve(item);
          } else {
            resolve(item);
          }
        }
        exec();
      })
    },

    // 彩超B超检查数据同步
    submitBReportForm() {
      const { templateId } = this.current;

      let templateParamV2List = [...(this.form.templateParamV2List || [])];
      templateParamV2List = templateParamV2List.map(item => {
        if(item.templateId === templateId) {
          // item.result = this.current.bData?.result;
          // item.diagnosis = this.current.bData?.diagnosis;
          if(!item.attributeParamV2List || item.attributeParamV2List.length === 0) {
            item.attributeParamV2List = this.attributeParamV2List || [];
          }
          item.originPDF = this.current.bData?.originPDF && typeof this.current.bData?.originPDF === 'string' ? this.current.bData?.originPDF : this.current.bData?.originPDF?.join(',');
          if(item.attributeParamV2List && item.attributeParamV2List[0]) {
            item.attributeParamV2List[0].result = this.current.bData?.result;
            item.attributeParamV2List[0].diagnosis = this.current.bData?.diagnosis;
            item.isUpdated = true;
          }
        }

        return item;
      });

      this.form = {
        ...this.form,
        templateParamV2List: templateParamV2List
      }
      console.log(this.form, templateParamV2List);
      this.openReportB = false;
    },
    /** 查询用户报告主记录列表 */
    getList() {
      this.loading = true;

      this.queryParams.reportDateStart = this.dateRange[0];
      this.queryParams.reportDateEnd = this.dateRange[1];

      listReportUserTotal(this.queryParams).then(response => {
        this.totalList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },


    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        userId: null,
        reportName: null,
        reportDate: null,
        createDate: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange= [];
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.isEdit = false;
      this.reset();
      this.open = true;
      this.personList = [];
      this.title = "添加用户报告主记录";
      // this.searchListUserAllinfo();
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.isEdit = true;
      this.reset();
      const id = row.id || this.ids
      this.current.userId = id;
      getReportTotalById(id).then(response => {
        const _form = {
          ...(response.data || {}),
          templateParamV2List: response.data?.templateParamV2List.map(item => {
            item.isUpdated = true;

           return item;
          })
        };
        // 请求回来默认已同步
        this.form = _form;
        this.open = true;
        this.title = "修改用户报告主记录";
        this.personList = [];

        this.searchListUserAllinfo('', row.userId);
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {

          console.log(this.form);
          if (this.form.id != null) {
            saveOrUpdate(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          } else {
            saveOrUpdate(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    async copyReportResultList(){
      try {
        var text = await this.getClipboardContent();

        var resultList = text?.split("\n") || [];
        console.log(resultList);
        if(resultList.length !== this.attributeParamV2List.length){
          this.$message.error('粘贴板的行数和表格模板的行数不一致');
          return
        }
        let attributeParamV2List= this.attributeParamV2List.map((item,index) => {
          return{
            ...item,
            result: resultList[index],
          }
        })
        this.attributeParamV2List = attributeParamV2List;
      } catch(e) {
        this.$message.error('获取剪贴板内容失败');
      }
    },
    getClipboardContent() {
      let that = this;
      return new Promise(async (resolve, reject) => {
        if(navigator.clipboard){
          navigator.clipboard
            .readText()
            .then((v) => {
              resolve(v);
            })
            .catch((v) => {
              reject();
              // that.$message.error('获取剪贴板内容失败');
            });
        } else {

        //   const editableDiv = document.createElement('input');
        //   editableDiv.style = 'position:fixed;left:0;top:0;background: red;width: 200px;z-index: 10000000;';
        //   document.body.appendChild(editableDiv);
        //   // 绑定粘贴事件监听器
        //   editableDiv.addEventListener('paste', function(event) {
        //     // 阻止默认粘贴行为，以便自定义处理
        //     event.preventDefault();

        //     // 使用Clipboard API获取粘贴内容
        //     var clipboardData = event.clipboardData || window.clipboardData;
        //     var pastedData = clipboardData.getData('text/plain');

        //     // 在控制台打印粘贴的内容
        //     console.log('Pasted content:', pastedData);


        //     // 自定义处理粘贴内容，例如修改后插入
        //     // editableDiv.textContent += ' - Modified: ' + pastedData;

        //     // 如果需要，可以在这里执行其他操作，如验证、过滤或修改粘贴的内容
        // });
        // editableDiv.focus();
        // document.execCommand('paste');
          // console.log('老版本浏览器兼容剪切板');
          // let text = await clipboard.readText();
          // resolve(text);


          // navigator.permissions.query({ name: 'clipboard-read' }).then((res) => {
          //   console.log(res);

          //   // 创建一个临时的input元素用于接收要复制的文本
          //   const input = document.createElement('input');
          //   input.style = 'position:fixed;left:0;top:0;background: red;width: 200px;z-index: 10000000;';
          //   document.body.appendChild(input);
        
          //   // 选中临时input元素中的文本
          //   input.focus();
        
          //   // 执行复制操作
          //   const result = document.execCommand('paste');
          //   console.log(input.innerText, result)
          // });

          
      
          // 移除临时input元素
          // document.body.removeChild(input);

          try {
            let contentEditable = document.createElement('div'); // 新建元素
            contentEditable.contentEditable = true; // 允许该元素中的文本可编辑
            document.body.appendChild(contentEditable); // 添加元素到body中
            contentEditable.focus(); // 元素获得焦点
            document.execCommand('paste'); // 获取剪贴板中的内容
            let text = contentEditable.innerText; // 从该元素中读取内容
            document.body.removeChild(contentEditable); // 移除元素

            resolve(text);
          } catch(e) {
            console.log(e);
            reject();
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除用户报告主记录编号为"' + ids + '"的数据项？').then(function() {
        return delReportUserTotal(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('biz/reportUserTotal/export', {
        ...this.queryParams
      }, `total_${new Date().getTime()}.xlsx`)
    },
    // 计算报告完成度
    getReportComplete(row) {
      const { attributeParamV2List = [] } = row || {};

      const total = attributeParamV2List?.length || 0;
      const finished = attributeParamV2List.filter(item => item.result || item.result === 0).length;
      return {
        total,
        finished,
        unfinished: total - finished
      }
    }
  }
};
</script>
